export const GET_FORM_SNAPSHOTS = 'forms/byId/snapshots';
export const GET_FORM_BY_SNAPSHOT_ID = 'forms/bySnapshotId';
